export const flightSafety = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 18,
  inputPaddingInline: 10,

  inputHeight: 42,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 16,
  inputFontFamily: '"Helvetica Neue", sans-serif',
  inputColor: "#041C2C",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 500,

  inputBorderColor: "transparent",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#041C2C",
  inputHoverBorderColor: "transparent",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 18,
  selectPaddingInline: 10,

  selectHeight: 42,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 16,
  selectFontFamily: '"Helvetica Neue", sans-serif',
  selectColor: "#041C2C",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 500,

  selectBorderColor: "transparent",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#041C2C",
  selectHoverBorderColor: "transparent",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 18,
  textAreaPaddingInline: 10,

  textAreaHeight: 42,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 16,
  textAreaFontFamily: '"Helvetica Neue", sans-serif',
  textAreaColor: "#041C2C",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 500,

  textAreaBorderColor: "transparent",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#041C2C",
  textAreaHoverBorderColor: "transparent",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#041C2C",
  placeholderFontFamily: '"Helvetica Neue", sans-serif',
  placeholderFontSize: 16,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#041C2C",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 16,
  fieldLabelColor: "#041C2C",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#041C2C",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Helvetica Neue", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#041C2C",
  descriptionFontSize: 16,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Helvetica Neue", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 20,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 2,
  checkboxUncheckedBorderColor: "#707070",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#007398",
  checkboxCheckedBorderColor: "#707070",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Helvetica Neue", sans-serif',
  checkboxLabelFontSize: 16,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#041C2C",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 20,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#707070",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#007398",
  radioCheckedBorderColor: "#707070",

  radioAlignment: "none",

  radioLabelFontFamily: '"Helvetica Neue", sans-serif',
  radioLabelFontSize: 16,
  radioLabelFontWeight: 400,
  radioLabelColor: "#041C2C",

  // **********************************
  // submit button

  submitMarginTop: 31,
  submitFontSize: 20,
  submitFontFamily: "'Helvetica Neue', sans-serif",
  submitWidth: 104,
  submitWidthUnits: "px",
  submitHeight: 56,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#007398",
  submitColor: "#ffffff",
  submitBorderColor: "#007398",
  submitBackgroundHover: "#007398",
  submitBorderColorHover: "#007398",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "right",
};

  